/*
 * @Author: ranmiaomiao
 * @Date: 2024-01-25 21:35:31
 * @LastEditors: Do not edit
 * @LastEditTime: 2024-01-25 23:10:25
 * @Description: 企业商标搜索接口
 * @FilePath: \fe-frame-page\src\api\tmSearchH5.js
 */
import request from "@/utils/request";

// 获取ncl分类(一级)
export function getNclOne() {
  return request({
    url: "/apis/api/tmReport/getNclOne",
    method: "get",
  });
}

// 获取行业列表
export function getBusiness(params) {
  return request({
    url: "/tmReport/getBusiness",
    method: "get",
    params,
  });
}
